import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { contextSchema, ISchemaContext } from "../constants/schemaContext";
import {
    selectLanguage,
    useLoggedInUser,
    useUsersAppRoles,
    useAuthentication,
} from "../auth/store/authSelectors";
import { DisplayView, IFormSchema, IFormWithRules } from "../../../sg-schema-form";
import { isLoaded } from "../../../sg-core";

import { useApplicationConfiguration } from "../configuration/ConfigurationContext";
import { IFormContextDispaly } from "../interfaces/FormContext";
import extraActions from "../schema/extraActions";
import { EAppLanguages } from "../../../@common/utils/localization";

const transformSchemaForDisplay = (schema: IFormSchema["schema"]) => {
    let newSchema = { ...schema };
    delete newSchema.title;
    return newSchema;
};

interface ISchemaDisplay extends IFormWithRules {
    canViewNames: boolean;
    /*  schema: IFormSchema["schema"];
      uiSchema: IFormSchema["uiSchema"];
      formData?: { [key: string]: any };
      rules?: { [key: string]: any }[];
      translations?: { [key: string]: any };*/
}

const SchemaDisplay: React.FC<ISchemaDisplay> = ({
    formSchema,
    // rules = [],
    //  schema,
    //  uiSchema,
    formData = {},
    children,
    onSubmit,
    onError,
    liveValidate,
    //  translations,
    canViewNames,
    ...otherProps
}) => {
    const { i18n } = useTranslation();
    const config = useApplicationConfiguration();

    const user = useLoggedInUser();
    const lang = (useSelector(selectLanguage) as EAppLanguages) || EAppLanguages.FI;
    const { token, anonymousSession } = useAuthentication();
    const appRoles = useUsersAppRoles();

    // const roleList = user ? user.roles.map(({ reference }) => reference).filter((value) => value) : []

    // If there's translations, add them to the namespace
    if (formSchema.translations) {
        const translations = formSchema.translations;
        const keys = Object.keys(translations);
        keys.forEach((key) => {
            i18n.addResourceBundle(key, "schema", translations[key]);
        });
    }

    const contextData: ISchemaContext = {
        roles: isLoaded(appRoles) ? appRoles.data : [],
        canViewNames,
        mode: "display",
        status: formData.tila || "luonnos",
        allowChangingProcessingMarkingPublicity: config.allowChangingProcessingMarkingPublicity,
    };

    const formContextData: IFormContextDispaly = {
        apiToken: token,
        anonymousSession,
        lang,
        formData,
        emptyValue: "-",
    };

    const displaySchema = transformSchemaForDisplay(formSchema.schema);

    const key = String(canViewNames) + JSON.stringify(formData);

    const schemas: IFormSchema = {
        ...formSchema,
        schema: displaySchema as any,
        rules: formData.laaja_sijainti
            ? formSchema.rules?.filter(
                  (rule) => typeof rule.conditions["laaja_sijainti.sijainti"] === "undefined",
              )
            : formSchema.rules,
    };
    console.log(schemas);
    return (
        <DisplayView
            key={key} // Makes sure component rerenders
            {...(otherProps as any)}
            configurations={config.jsonSchema}
            formSchema={schemas}
            formData={formData}
            contextData={contextData}
            contextSchema={contextSchema as any}
            formContext={formContextData}
            extraActions={extraActions}
            children={<div />}
        />
    );
};

SchemaDisplay.defaultProps = {};
export default SchemaDisplay;
